import { PATHS } from "Utils/PagePaths";

// {
//   title: "",
//   desc: "",
//   numbers: [],
//   links: {},
//   moreDesc: []
// }
export const COMMON_FORMATS_CARDS_DATA = [
  {
    title: "Surveillance - Hospital Version 1.0",
    desc: "Common Formats for Surveillance (CFS-H) are designed to be used in retrospective health record review to identify whether specified patient"
      + "safety events occurred. They complement the Common Formats for Event Reporting, which are designed to provide a framework for the collection of"
      + "data on patient safety concerns when they occur.",
    numbers: [],
    links: {
      learnMore: PATHS.public["Surveillance - Hospital"],
      downloadAllResources: "2845"
    },
    moreDesc: [
      <>
        <div className="card-title-more">
          The CFS-H Version 1.0 provide standardized templates and guidelines for retrospective reporting of various patient safety events.
        </div>
        <br />
        <ul>
          <li>
            Definitions of adverse events detail the criteria for creating numerators for reporting.
          </li>
          <li>
            Populations at risk are defined for each adverse event. These detail the eligibility criteria for creating denominators for reporting.
          </li>
        </ul>
      </>,
      <>
        <div className="card-title-more">
          The CFS-H Version 1.0 defines additional types of information that facilitate more comprehensive reporting including:
        </div>
        <br />
        <ul>
          <li>
            Information that adds context to specific adverse events and provides fuller reporting such as risk assessments, preventive actions,
            descriptive information, risk factors, and contributing factors.
          </li>
          <li>
            Administrative data related to a patient stay such as patient demographics, payer information, type of patient stay, diagnosis codes,
            and procedure codes.
          </li>
        </ul>
      </>
    ]
  },
  {
    title: "Diagnostic Safety Version 1.0",
    desc: "Intended for use across healthcare settings, this format focuses on patient safety events involving delayed, wrong, or missed diagnoses and failures to communicate accurate diagnoses.",
    numbers: [
      {
        number: 3,
        desc: "Report Types"
      },
      {
        number: 1,
        desc: "Event Type"
      },
      {
        number: 56,
        desc: "Data Elements"
      },
      {
        number: 6,
        desc: "Standard Code Systems"
      }
    ],
    links: {
      learnMore: PATHS.public["Diagnostic Safety"],
      downloadAllResources: "2844"
    },
    moreDesc: [
      <div>
        <span className="card-title-more">Report Type</span> refers to Incident, Near Miss, and Unsafe Condition.
      </div>,
      <div>
        <span className="card-title-more">Event Type</span> refers to the events that can be reported in Diagnostic Safety Version 1.0. A Diagnostic Safety Event occurs when there are missed opportunities to make a timely and accurate diagnosis or when an accurate diagnosis is made but not communicated to the patient or their representative.
      </div>,
      <div>
        <span className="card-title-more">Total Number of Data Elements</span>  refers to the number of fields included in the format for data collection. Not all fields are required.
      </div>,
      <div>
        <span className="card-title-more">Standard Code Systems</span> for Diagnostic Safety Version 1.0 include SNOMED-CT, HL7 NullFlavor, ISO 639-3 Language, Healthcare Service Location (HL7), ICD-10-CM (diagnosis codes), and CDC Race and Ethnicity.
      </div>
    ]
  },
  {
    title: "Nursing Home Version 1.0",
    desc: "Designed for nursing home settings, this format addresses patient safety concerns specific to long-term care, including events related to resident care, medication use, and environmental safety.",
    numbers: [
      {
        number: 3,
        desc: "Report Types"
      },
      {
        number: 9,
        desc: "Event Types"
      },
      {
        number: 62,
        desc: "Data Elements"
      },
      {
        number: 4,
        desc: "Standard Code Systems"
      }
    ],
    links: {
      learnMore: PATHS.public["Nursing Home"],
      downloadAllResources: "2846"
    },
    moreDesc: [
      <div>
        <span className="card-title-more">Report Type</span> refers to Incident, Near Miss, and Unsafe Condition.
      </div>,
      <div>
        <span className="card-title-more">Event Type</span> refers to the events that can be reported in Nursing Home Version 1.0. These include: Device or Medical/Surgical Supply, Fall, HAI, Medication or Other Substance, Pressure Injury, Abuse or neglect, Accident (e.g., scalding, choking, and/or restraint related), Elopement, and Other.
      </div>,
      <div>
        <span className="card-title-more">Total Number of Data Elements</span>  refers to the number of fields included in the format for data collection. Not all fields are required.
      </div>,
      <div>
        <span className="card-title-more">Standard Code Systems</span>  for Nursing Home Version 1.0 include HL7 Administrative Gender, HL7 NullFlavor, RxNorm, and CDC Race and Ethnicity.
      </div>
    ]
  },
  {
    title: "Hospital Version 2.0",
    desc: "To help reduce the reporting burden, Hospital Version 2.0 streamlines reporting by introducing core and supplemental data sets which decreased the number of data elements.",
    numbers: [
      {
        number: 3,
        desc: "Report Types"
      },
      {
        number: 11,
        desc: "Event Types"
      },
      {
        number: 89,
        desc: "Data Elements"
      },
      {
        number: 6,
        desc: "Standard Code Systems"
      }
    ],
    links: {
      learnMore: PATHS.public["Hospital Version 2.0"],
      downloadAllResources: "2854"
    },
    moreDesc: [
      <div>
        <span className="card-title-more">Report Type</span> refers to Incident, Near Miss, and Unsafe Condition.
      </div>,
      <div>
        <span className="card-title-more">Event Type</span> refers to the events that can be reported in Hospital Version 2.0. These include: Anesthesia, Blood, Device or Medical/Surgical Supply, Fall, HAI, Medication or Other Substance, Perinatal, Pressure Injury, Surgery, includes invasive procedure, and Venous Thromboembolism.
      </div>,
      <div>
        <span className="card-title-more">Total Number of Data Elements</span>  refers to the number of fields included in the format for data collection. Not all fields are required.
      </div>,
      <div>
        <span className="card-title-more">Standard Code Systems</span> for Hospital Version 2.0 include HL7 NullFlavor, HL7 Administrative Gender, RxNorm, SNOMED CT, CDC Race and Ethnicity, and Healthcare Service Location (HL7).
      </div>
    ]
  },
  {
    title: "Community Pharmacy Version 1.0",
    desc: "Designed for use in community pharmacy settings, this format addresses patient safety concerns related to medication dispensing, counseling, and other pharmacy services.",
    numbers: [
      {
        number: 3,
        desc: "Report Types"
      },
      {
        number: 1,
        desc: "Event Type"
      },
      {
        number: 44,
        desc: "Data Elements"
      },
      {
        number: 3,
        desc: "Standard Code Systems"
      }
    ],
    links: {
      learnMore: PATHS.public["Community Pharmacy"],
      downloadAllResources: "2843"
    },
    moreDesc: [
      <div>
        <span className="card-title-more">Report Type</span> refers to Incident, Near Miss, and Unsafe Condition.
      </div>,
      <div>
        <span className="card-title-more">Event Type</span> refers to the events that can be reported in Community Pharmacy Version 1.0. A Community Pharmacy event involves drugs, biological products, nutritional products, or medical foods.
      </div>,
      <div>
        <span className="card-title-more">Total Number of Data Elements</span> refers to the number of fields included in the format for data collection. Not all fields are required.
      </div>,
      <div>
        <span className="card-title-more">Standard Code Systems</span> for Community Pharmacy Version 1.0 include HL7 Administrative Gender, NDC, and RxNorm.
      </div>
    ]
  },
  {
    title: "Hospital Version 1.2",
    desc: "Meant for use in the hospital setting, this format is limited to issues of patient safety – preventing harm to patients from the delivery of health care services.",
    numbers: [
      {
        number: 3,
        desc: "Report Types"
      },
      {
        number: 10,
        desc: "Event Types"
      },
      {
        number: 209,
        desc: "Data Elements"
      },
      {
        number: 10,
        desc: "Standard Code Systems"
      }
    ],
    links: {
      learnMore: PATHS.public["Hospital Version 1.2"],
      downloadAllResources: "2851"
    },
    moreDesc: [
      <div>
        <span className="card-title-more">Report Type</span> refers to Incident, Near Miss, and Unsafe Condition.
      </div>,
      <div>
        <span className="card-title-more">Event Type </span> refers to the events that can be reported in Hospital Version 1.2. These include: Blood, Device or Medical/Surgical Supply, Fall, HAI, Medication or Other Substance, Perinatal, Pressure Injury, Surgery, includes invasive procedure, and Venous Thromboembolism.
      </div>,
      <div>
        <span className="card-title-more">Total Number of Data Elements</span>  refers to the number of fields included in the format for data collection. Not all fields are required.
      </div>,
      <div>
        <span className="card-title-more">Standard Code Systems </span> for Hospital Version 1.2 include HL7 Administrative Gender, RxNorm, SNOMED CT, CDC Race and Ethnicity, Healthcare Service Location (HL7),  ICD-9 CM (diagnosis codes), ICD-10 CM (diagnosis codes), ICD-9 PCS (procedure codes), ICD-10 PCS (procedure codes), and  ISBT 128.
      </div>
    ]
  }
]